import { StylesConfig } from 'react-select'
import colors from '../../constants/colors'

export const componentStyles: StylesConfig = {
  multiValue: (base) => ({
    ...base,
    backgroundColor: 'transparent',
    border: `1px solid ${colors.black10}`,
    borderRadius: '8px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
  }),
  multiValueLabel: (base) => ({
    ...base,
    fontSize: '12px',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: colors.black50,
  }),
  menu: (base) => ({
    ...base,
    marginTop: 0,
    display: 'flex',
  }),
  menuList: (base) => ({
    ...base,
    width: '100%',
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: '14px',
    color: colors.black25,
  }),
}
